/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedOneDWaterLevel
 */
export interface PatchedOneDWaterLevel {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  value?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedOneDWaterLevel interface.
 */
export function instanceOfPatchedOneDWaterLevel(value: object): value is PatchedOneDWaterLevel {
  return true;
}

export function PatchedOneDWaterLevelFromJSON(json: any): PatchedOneDWaterLevel {
  return PatchedOneDWaterLevelFromJSONTyped(json, false);
}

export function PatchedOneDWaterLevelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedOneDWaterLevel {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    value: json["value"] == null ? undefined : json["value"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedOneDWaterLevelToJSON(json: any): PatchedOneDWaterLevel {
  return PatchedOneDWaterLevelToJSONTyped(json, false);
}

export function PatchedOneDWaterLevelToJSONTyped(
  value?: Omit<PatchedOneDWaterLevel, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
